import React from 'react'
import flowRight from 'lodash/flowRight'

import { ErrorView, Loading } from '@fielded/shared-ui'

import { withUser } from '../../../../../common/AuthenticationProvider'
import withConfig from '../../../../../van-shared/hoc/withConfig'
import { withApi } from '../../../../../common/ApiProvider'
import useShipments from '../hooks/useShipments'
import PSMInboundShipments from './PSMInboundShipments'

const PSMInboundShipmentsContainer = ({
  api,
  user,
  config,
  history
}) => {
  const {error, locationName, shipments, loading} = useShipments({
    api, user, config, key: 'all', filters: shipment => shipment.statusType === 'arrival'
  })

  if (error) {
    return <ErrorView title='Shipment' error={error} />
  }

  if (loading) {
    return <Loading loadingText='Loading completed shipments …' />
  }

  return (
    loading
      ? <div />
      : <PSMInboundShipments
        config={config}
        shipments={shipments}
        history={history}
        fullLocationName={locationName}
      />
  )
}

const withHOCs = flowRight(
  withApi,
  withUser,
  withConfig
)

export default withHOCs(PSMInboundShipmentsContainer)
